import { FEED_FILTER, FEED_RANGE } from 'app/constants/feed'
import { LAUNCH_PATH } from 'app/constants/navLinks'

export function parseQuery(query) {
  const vars = query.split('&')
  const query_string = {}
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    // If first entry with this name
    if (typeof query_string[pair[0]] === 'undefined') {
      query_string[pair[0]] = decodeURIComponent(pair[1])
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === 'string') {
      const arr = [query_string[pair[0]], decodeURIComponent(pair[1])]
      query_string[pair[0]] = arr
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]))
    }
  }
  return query_string
}

export const parseRequestParamsForFeed = (team, range) => {
  const isDefaultTeam = team === FEED_FILTER
  const isDefaultRange = range === FEED_RANGE.all
  if (isDefaultTeam && isDefaultRange) {
    return '/leaderboard'
  }
  if (!isDefaultTeam && isDefaultRange) {
    return `/leaderboard?team=${team}`
  }
  if (!isDefaultRange && isDefaultTeam) {
    return `/leaderboard?dayRange=${range}`
  }
  return `/leaderboard?team=${team}&dayRange=${range}`
}

export const getOrganizationDomainFromUrl = hostname => {
  const host = hostname.split('.')
  if (host instanceof Array) {
    if (host[0] === 'localhost') {
      return 'sandbox'
    }
    return host[0]
  }
  return host
}

export function cutAddressBeforeLaunchAtUrl(address: string) {
  return `/${address.slice(address.indexOf(LAUNCH_PATH))}`
}

export const getSeparatedUrlAndQueryString = urlWithQueryParams => {
  const questionMarkIndex = urlWithQueryParams.indexOf('?')
  const url = urlWithQueryParams.slice(0, questionMarkIndex)
  // questionMarkIndex + 1 needs for reason to not include question mark in the query string
  const queryString = urlWithQueryParams.slice(questionMarkIndex + 1)
  return {
    url,
    queryString,
  }
}
